import { GlobalStyle as fixelGlobalStyle } from "@fixel/fixel-components";
import { createGlobalStyle, css } from "styled-components/macro";

export const bodyStyles = css`
	font-family: inherit;
`;

export const GlobalStyle = createGlobalStyle`
 body {
   ${fixelGlobalStyle}
 }
`;
